import gql from 'graphql-tag';

export const insightFieldsFragment = gql`
    fragment insightFields on Insight {
        uuid
        status
        date
        path
        title
        audience
        type
        authorName
        imageURL
        videoURL
        body
        header
        inverse
        externalPath
        private
        summary
        standalone
        subTitle
        hideDay
        videoPoster
        isVersion
        hasChanges
        previewStatus
    }
`;

export const insightsPaginationFragment = gql`
    fragment insightsPagination on InsightList {
        page
        limit
        total
        count
    }
`;
